import { Tag } from "antd";
import t from "../../../../app/i18n";
import { PresetColors } from "../../../../common/constants";
import { CommissionsSettingsLevelType } from "../enums";

interface Props {
  type: CommissionsSettingsLevelType;
  style?: React.CSSProperties;
  closable?: boolean;
  onClose?: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

const CommissionsLevelTypeTag = ({ type, style, closable, onClose }: Props) => {
  let color: string;

  switch (type) {
    case CommissionsSettingsLevelType.BASIC:
      color = PresetColors.BLUE;
      break;
    case CommissionsSettingsLevelType.POINT:
      color = PresetColors.MAGENTA;
      break;
    case CommissionsSettingsLevelType.CAREER:
      color = PresetColors.GOLD;
      break;
  }

  return (
    <Tag color={color} style={style} closable={closable} onClose={onClose}>
      {t("commissions.level.enums.type." + type)}
    </Tag>
  );
};

export default CommissionsLevelTypeTag;
